module.exports = __webpack_public_path__ + "img/实时监测和报告.66eb45b9.png";